export function chartConfig(data, isPc = true) {
  return {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    color: data.map(item => item.color),
    series: [
      {
        name: '模型分布',
        type: 'pie',
        radius: ['35%', '60%'],
        avoidLabelOverlap: true,
        itemStyle: {
          borderWidth: 1,
          borderColor: '#ffffff',
        },
        label: {
          show: true,
          position: 'outside',
          formatter: ({ name, percent }) => `{name|${name}}{percent|${percent.toFixed(1)}%}`, // 为名称添加富文本标签
          rich: {
            percent: {
              color: '#fff',
              fontWeight: 'bold',
              fontSize: isPc ? 14 : 10, // 调大百分比字号
              padding: [2, 4],
              borderRadius: 4,
            },
            name: {
              color: '#fff', // 直接使用白色文字
              fontSize: isPc ? 12 : 10, // 单独设置名称字号
              align: 'center',
              textBorderWidth: 0, // 明确去掉文字描边
            },
          },
        },
        labelLine: {
          show: true,
          length: 10,
          length2: 20,
          color: 'rgba(255, 255, 255, 0.5)',
        },
        data,
      },
    ],
  }
}
